import React, {useEffect, useState} from "react";
import {
    IonButton,
    IonContent, IonIcon,
    IonInput, IonItem, IonList,
    IonPage,
    IonSelect,
    IonSelectOption,
    useIonViewDidEnter,
    useIonViewWillLeave
} from "@ionic/react";
import {useTranslation} from "react-i18next";
import {Farecard, Institution} from "../services/types/apitypes";
import {apiGetInstitutionsForCard, apiUnlinkCardToInstitution} from "../services/api";
import useEnhancedAuth from "../EnhancedAuth";
import {useHistory, useParams} from "react-router";
import AppPageHeader from "../components/AppPageHeader";
import {useToaster} from "../hooks/useToaster";
import {getAppError, getAppSuccess, getUserMessageOrValidationError} from "../utils/messages";
import {uiInputMode} from "../utils/ui";
import AppLoading from "../components/AppLoading";
import InstitutionBox from "../components/InstitutionBox";
import image from "../usecases/farecard/Institution.svg";
import AppModal from "../components/AppModal";

export const InstitutionsRegisterPageList: React.FC = () => {

    const {t} = useTranslation('global');
    const { cardid } = useParams<{ cardid: string }>();

    const router = useHistory()

    const [present] = useToaster();

    const [selectedCard, setSelectedCard] = useState<Farecard | undefined>(
        undefined,
    );

    const [isPageActive, setIsPageActive] = useState(false);
    useIonViewDidEnter(() => {
        setIsPageActive(true);
        loadFareCard();
    });
    useIonViewWillLeave(() => {
        setIsPageActive(false);
    });

    const [institutions, setInstitutions] = React.useState<Institution[]>([]);
    const auth = useEnhancedAuth();

    const [registrationCode, setRegistrationCode] = React.useState<string | undefined>(undefined);
    const [institution, setInstitution] = React.useState<Institution | undefined>(undefined);
    const [error, setError] = React.useState<string | undefined>(undefined);
    const [submitting, setSubmitting] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [selectedInstitution, setSelectedInstitution] = useState<Institution | undefined>(undefined);
    const [showModal, setShowModal] = useState<boolean>(false);

    const loadFareCard = async () => {
        setLoading(true);
        try {
            const institutions = (await apiGetInstitutionsForCard(auth, cardid)).data;
            setInstitutions(institutions);
        } catch (e: unknown) {
            const apiError = getUserMessageOrValidationError(error);
            if (typeof apiError === 'string') {
                present(getAppError(apiError));
            }
        } finally {
            setLoading(false);
        }
    }


    function goBack() {
        if (!selectedInstitution) {
            router.push('/card/' + cardid + '/options');
        } else {
            setSelectedInstitution(undefined);
        }
    }

    async function unlink() {
        if (!selectedInstitution) return;
        try {
            setSubmitting(true);
            const result = await apiUnlinkCardToInstitution(auth, selectedInstitution.id, cardid);
            if (result) {
                present(getAppSuccess(t('institutions.unlink_success')));
                setSelectedInstitution(undefined);
                loadFareCard();
            }
        } catch (e: unknown) {
            const apiError = getUserMessageOrValidationError(e);
            if (typeof apiError === 'string') {
                present(getAppError(apiError));
            }
            console.log("error presented", apiError)
        } finally {
            setSubmitting(false);
            setShowModal(false);
        }
    }

    return <IonPage id="farecardvalue-page">
        <AppPageHeader
            isPageActive={isPageActive}
            back={goBack}
            title={selectedInstitution ? t('institutions.detail_title') : t('institutions.title')}
        ></AppPageHeader>

        <AppLoading hidden={!loading && !submitting} />
        <AppModal isOpen={showModal} close={() => setShowModal(false)}>
            <div style={{"display": "flex", "flexFlow": "column", "gap": "0.375rem", "marginBottom": "1.5rem", alignItems: "center"}}>
                <IonIcon src={"assets/icon/warning.svg"} style={{"height": "5.5rem", width: "5.5rem"}}></IonIcon>

                <h1 className="h1 pt-2 ion-text-center h1plus">{t('institutions.unlink_institution')}</h1>
                <p className="pt-1 instructions">{t('institutions.unlink_institution_hint')}</p>
                <IonButton
                    className={"btn-default btn-warn btn-wide-100"}
                    fill={'solid'}
                    disabled={submitting}
                    onClick={() => unlink()}>{t('institutions.unlink_yes')}</IonButton>
                <IonButton className={"btn-inverted btn-wide-100"} fill={"outline"} disabled={submitting} onClick={() => setShowModal(false)}>{t('institutions.cancel')}</IonButton>
            </div>
        </AppModal>

        {institutions.length > 0 ?
            <IonContent fullscreen className="ion-padding default-content">
                {!selectedInstitution ?
                institutions.map(i => <>
                        {<InstitutionBox hideAddress={true} institution={i} onClick={() => setSelectedInstitution(i)}></InstitutionBox>}
                </>) : <>
                        <InstitutionBox hideAddress={false} institution={selectedInstitution}></InstitutionBox>
                        <IonButton className={"btn-inverted btn-warn btn-wide-100"} fill={"outline"} disabled={submitting} onClick={() => setShowModal(true)}>{t('institutions.unlink_institution')}</IonButton>
                    </>}
            </IonContent>
            :
            <IonContent fullscreen className="ion-padding default-content">
                <div className="pt-3 farcards-nocard" onClick={() => router.push('/card/' + cardid + '/institution/register')}>
                    <img src={image} height={44} alt={t('institutions.link_institution')!} />
                </div>
                <h1 className="h1 pt-2 ion-text-center h1plus">{t('institutions.none_linked')}</h1>
                <p className="pt-1 instructions">{t('institutions.none_linked_hint')}</p>

                <div className="pt-5 ion-text-center">
                    <IonButton
                        className="btn-default btn-wide-80"
                        onClick={() => router.push('/card/' + cardid + '/institution/register')}
                    >
                        {t('institutions.link_institution')}
                    </IonButton>
                </div>
            </IonContent>}



    </IonPage>
}